import * as React from 'react';

import AdminReferences32 from './AdminReferences32';

export const adminReferences32 = () => <AdminReferences32 />;

export default {
    title: 'Icon/Logo/AdminReferences32',
    component: AdminReferences32,
    parameters: {
        notes: "`import AdminReferences32 from 'box-ui-elements/es/icon/logo/AdminReferences32';`",
    },
};
